import { render, staticRenderFns } from "./NkTable.vue?vue&type=template&id=f2116db0&scoped=true"
import script from "./NkTable.vue?vue&type=script&lang=js"
export * from "./NkTable.vue?vue&type=script&lang=js"
import style0 from "./NkTable.vue?vue&type=style&index=0&id=f2116db0&prod&lang=scss"
import style1 from "./NkTable.vue?vue&type=style&index=1&id=f2116db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2116db0",
  null
  
)

export default component.exports